<mat-card appearance="outlined" class="profile-card" *ngIf="wasteProfile">
  <mat-card-title class="title">
    <span class="left-content" *ngIf="!showApprovedDate">
      Submitted {{ wasteProfile.submittedDate | date: dateFormat }}
    </span>
    <span class="left-content" *ngIf="showApprovedDate">
      Approved {{ wasteProfile.approvedDate | date: dateFormat }}
    </span>
  </mat-card-title>
  <mat-card-content>
    <div class="card-details">
      <div class="profile">
        <span class="profile-title">{{ wasteProfile.name }}</span>
        <span class="profile-details">{{ wasteProfile.generator?.name }}</span>
        <span class="profile-address">{{
          wasteProfile.generator?.siteAddress | address
        }}</span>
        <span class="approver-name" *ngIf="wasteProfile.coordinator?.name"
          >Coordinator: {{ wasteProfile.coordinator.name }}
        </span>
        <span class="approver-name" *ngIf="wasteProfile.approverName"
          >Analyst: {{ wasteProfile.approverName }}
        </span>
      </div>
      <div class="status" fxLayout="column" fxLayoutAlign="start end">
        <digital-platform-status-chip [status]="wasteProfile.internalStatus">
        </digital-platform-status-chip>
        <span class="status-landfill">{{
          wasteProfile?.destination?.name
        }}</span>
        <span class="status-id">{{ wasteProfile.number }}</span>
      </div>
    </div>
    <ng-container>
      <div class="card-button" *ngIf="showReview">
        <a
          mat-button
          color="accent"
          class="action-required"
          *digitalPlatformPermission="'update:waste_profile_metadata'"
          routerLink="/update-metadata/{{ wasteProfile.id }}"
        >
          <mat-icon svgIcon="edit"></mat-icon>
          Review
        </a>
        <a
          mat-button
          color="accent"
          class="action-required"
          *digitalPlatformPermission="'view:waste_profile_search'"
          [routerLink]="'/special-waste-view/' + wasteProfile.id"
        >
          <mat-icon svgIcon="folder"></mat-icon>
          View Profile
        </a>
      </div>
    </ng-container>
    <ng-container>
      <div class="card-button" *ngIf="showViewProfile">
        <a
          mat-button
          color="accent"
          class="action-required"
          *digitalPlatformPermission="'update:waste_profile_metadata'"
          routerLink="/update-metadata/{{ wasteProfile.id }}"
        >
          <mat-icon svgIcon="folder"></mat-icon>
          View Profile
        </a>
        <a
          mat-button
          color="accent"
          class="action-required"
          *digitalPlatformPermission="'view:waste_profile_search'"
          [routerLink]="'/special-waste-view/' + wasteProfile.id"
        >
          <mat-icon svgIcon="folder"></mat-icon>
          View Profile
        </a>
      </div>
    </ng-container>
  </mat-card-content>
</mat-card>
